import { AdPlacement } from "@/components/ads/AdPlacement";
import { m } from "@/paraglide/messages";
import { MarkdownTableTool } from "../components/MarkdownTableTool";
import { MtBreadcrumb } from "../components/MtBreadcrumb";
import { MtExplainer } from "../components/MtExplainer";

export function MarkdownTablePage() {
  return (
    <div className="relative">
      <div className="pointer-events-none absolute inset-0 gradient-mesh" />
      <div className="relative mx-auto max-w-3xl px-4 py-12 sm:px-6 lg:px-8">
        <MtBreadcrumb />

        <header className="mb-8 mt-6">
          <h1 className="font-display text-3xl font-bold tracking-tight sm:text-4xl">
            {m.mt_h1()}
          </h1>
          <p className="mt-3 leading-relaxed text-muted-foreground">
            {m.mt_intro()}
          </p>
        </header>

        <MarkdownTableTool />

        <MtExplainer
          howTo={m.mt_howto()}
          faqs={[
            { q: m.mt_faq1_q(), a: m.mt_faq1_a() },
            { q: m.mt_faq2_q(), a: m.mt_faq2_a() },
            { q: m.mt_faq3_q(), a: m.mt_faq3_a() },
            { q: m.mt_faq4_q(), a: m.mt_faq4_a() },
          ]}
        />

        <AdPlacement className="mt-10" />
      </div>
    </div>
  );
}
